import {get} from "lodash"
import {AxiosError, AxiosResponse} from "axios"

import intercom from "@irati/utils/intercom"

import sentry from "../../../sentry"
import graphUrl from "../../../graph/utils/getUrl"
import getCodeFromError from "../../helpers/getCodeFromError"
import getDataFromError from "../../helpers/getDataFromError"
import getMessageFromErrorCode from "../../helpers/getMessageFromErrorCode"
import getTraceIdFromError from "../../helpers/getTraceIdFromError"

export default (err: AxiosError): PBError => {
  sentry.captureException(err)
  const e: PBError = err
  e.errorCode = getCodeFromError(err)
  e.message = getMessageFromErrorCode(e.errorCode, e)
  e.traceId = getTraceIdFromError(err)
  e.errorData = getDataFromError(err, e.traceId, e.errorCode)

  try {
    logErrorToIntercom({
      errorCode: e.errorCode,
      errorData: e.errorData,
      traceId: e.traceId,
      operationName: get(JSON.parse(e.response.config.data), "operationName")
    })
  } catch (error) {/* no-op */}

  throw e
}

export function getGraphError(res: AxiosResponse): AxiosResponse {
  if (!isGraphError(res)) {
    return res
  }

  console.log(res)
  const e: GraphError = new Error()
  e.apiError = get(res, "data.errors.[0].apiError", {})
  e.errorCode = getCodeFromError(res)
  e.message = getMessageFromErrorCode(e.errorCode, e)
  e.traceId = getTraceIdFromError(res)
  e.errorData = getDataFromError(res, e.traceId, e.errorCode)
  e.response = res

  try {
    logErrorToIntercom({
      errorCode: e.errorCode,
      errorData: e.errorData,
      traceId: e.traceId,
      operationName: get(JSON.parse(e.response.config.data), "operationName")
    })
  } catch (error) {/* no-op */}

  throw e
}

function isGraphError(res: AxiosResponse) {
  const url = get(res, "config.url", "")
  const errors = get(res, "data.errors") || []
  return url === graphUrl() && Array.isArray(errors) && errors.length > 0
}

function logErrorToIntercom(metadata: Pick<PBError, "errorCode" | "errorData" | "traceId"> & {operationName: string}) {
  return intercom.logError(metadata)
}
